import React from 'react';
import { bool, string } from 'prop-types';

import Spinner from '@johnlewispartnership/wtr-ingredients/dist/Spinner';
import { TrolleyInactive } from '@johnlewispartnership/wtr-ingredients/foundations/icons';
import styles from './TrolleyButtonContents.module.scss';

export const TrolleyButtonContents = ({
  estimatedCost,
  loadingStatus,
  hasTrolleyError,
  testIdSuffix,
}) => (
  <div className={styles.buttonWrapper} data-trolley-loading={loadingStatus} aria-hidden="true">
    {loadingStatus && (
      <div className={styles.spinnerOverlay}>
        <Spinner isActive size="small" data-testid="spinner" />
      </div>
    )}
    <TrolleyInactive size="small" />
    <span
      className={styles.anchorText}
      data-testid={`total-price-overview${testIdSuffix ? `-${testIdSuffix}` : ''}`}
    >
      {hasTrolleyError ? 'Trolley' : estimatedCost}
    </span>
  </div>
);

TrolleyButtonContents.propTypes = {
  estimatedCost: string,
  loadingStatus: bool,
  hasTrolleyError: bool,
  testIdSuffix: string,
};

TrolleyButtonContents.defaultProps = {
  estimatedCost: '',
  loadingStatus: false,
  hasTrolleyError: false,
  testIdSuffix: '',
};
